import React, { Component } from "react";
import Dropzone from 'react-dropzone';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Growl } from 'primereact/growl';
import { Message } from 'primereact/message';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import logo_upload from '../../imagen/subir_archivos.png';
import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioArchivos from '../servicios/ServicioArchivos';

export class FacturacionLineaExpress extends Component {
    constructor() {
        super();
        this.state = {
            archivos: [],
            listaArchivos: [],
            errores: {},
            resultado: [],
            inicio: 0
        };
    }

    onDrop = (files) => {
        var formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            var cfdi = files[i];
            formData.append('xml', cfdi);
        }
        this.setState({ archivos: formData, listadoArchivos: files.length });
    };

    guardarXml = () => {
        let { archivos } = this.state;
        let errores = this.validarFormulario(archivos);
        this.setState({ errores: errores });
        if (servicioObjetos.esObjetoVacio(errores)) {
            servicioHttp.consumirPostHttp('/linea/facturacion.json', archivos).then(response => {
                this.setState({ archivos: [], listadoArchivos: [], resultado: response.data.lista });
            });
        }

    }

    limpiarTabla = () => {
        this.setState({ archivos: [], listadoArchivos: [], resultado: [] });
    }

    validarFormulario = (archivos) => {
        const errores = {};
        if (archivos.values().next().done)
            errores.archivos = "El campo es requerido";
        return errores;
    }

    onIndexTemplate = (data, props) => {
        let { inicio } = this.state;
        return (props.rowIndex + 1) + inicio;
    }

    templateErrorResultado = (rowData, column) => {
        if (rowData.error === true)
            return <div className="p-col-12 p-md-2"><i className="pi-md-cancel"></i></div>;
        else
            return <div className="p-col-12 p-md-2"><i className="pi-md-check-circle"></i></div>;
    }

    templateDescargaArchivos = (rowData, column) => {
        if (rowData.error === false){
            return <div>
            <Button type="button" icon="pi-md-cloud-download" className="p-button-success" onClick={(e) => this.generaDescarga(rowData,"xml")}></Button>
        </div>;
        }
       
    }

    generaDescarga(objeto, tipo) {
        servicioArchivos.descargaArchivo('/documentos/descargar_documentos_zip_linea.json',{uuid: objeto.objeto.uuid});
    }

    render() {
        let { listadoArchivos, errores } = this.state;
        return (
            <div>
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <h1>  TIMBRAR XML'S DE LINEA EXPRESS</h1>
                </div>
                <div className="card card-w-title" style={{ marginBottom: '50px' }}>
                    <Dropzone accept=".xml" onDrop={this.onDrop}>
                        {({ getRootProps, getInputProps }) => (
                            <section className="container container__center">
                                <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                    <input   {...getInputProps()} />
                                    <img className="rectangulo-img-upload" src={logo_upload} alt='upload' />
                                    <p className="rectangulo-p-upload">Arrastra y suelta aquí los archivos xml's</p>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-lg-12">
                            {errores.archivos ? <div><br /> <Message severity="error" text={errores.archivos} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-lg-5"></div>
                        <div className="p-col-12 p-lg-4">
                            <h1>Archivos a procesar: {listadoArchivos}</h1>

                        </div>
                        <br />
                        <div className="p-col-12 p-lg-6">
                            <Button icon="pi pi-upload" label="Timbrar Xml's" onClick={this.guardarXml} />
                        </div>
                        {this.state.resultado.length === 0 ? "" :
                            <div className="p-col-12 p-lg-6">
                                <Button icon="pi pi-refresh" className="p-button-info" label="Limpiar Datos" onClick={this.limpiarTabla} />
                            </div>
                        }

                    </div>
                </div>


                <div className="p-grid">

                    {this.state.resultado.length === 0 ? "" :
                        <Card className="p-col-12 p-md-12">
                            <DataTable header="Resultado facturación" responsive={true} value={this.state.resultado}>
                                <Column field="Index" header="Número" body={this.onIndexTemplate} style={{ width: '100px' }} autoLayout={true} resizableColumns={true} />
                                <Column body={this.templateErrorResultado} header="Estado" />
                                <Column field="mensaje" header="Observación" />
                                <Column field="objeto.uuid" header="Folio Fiscal" />
                                <Column field="objeto.serie" header="Serie" />
                                <Column field="objeto.folio" header="Folio" />
                                <Column body={this.templateDescargaArchivos} style={{ textAlign: 'center', width: '8em' }} header="Descargar archivos" />
                            </DataTable>

                        </Card>
                    }
                </div>


            </div>);
    }

}